// extracted by mini-css-extract-plugin
export default {"invoice_details_container":"style_invoice_details_container__awn4T","no_margin":"style_no_margin__sjGEl"};